import React, { useState, useEffect, useContext } from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import "../../../node_modules/react-grid-layout/css/styles.css";
import "../../../node_modules/react-resizable/css/styles.css";
import { globalServices } from "../../Services/global.service";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";

const DashboardLayoutPerformance = (props) => {
  const { updatePerformances } = useContext(GlobalContext);
  const ResponsiveGridLayout = WidthProvider(Responsive);
  const { t: translator } = useTranslation();

  const onLayoutChange = (layout, layouts) => {
    saveToLocalStorage("layouts", layouts);
  };

  const saveToLocalStorage = (key, value) => {
    if (global.localStorage) {
      global.localStorage.setItem(
        "cardsOrderPerformance",
        JSON.stringify({
          [key]: value,
        })
      );
    }
  };

  const loadFromLocalStorage = (key) => {
    let localStorage = {};
    if (global.localStorage) {
      try {
        localStorage =
          JSON.parse(global.localStorage.getItem("cardsOrderPerformance")) ||
          {};
      } catch (e) {
        // ignore for now
      }
    }

    return localStorage["layouts"];
  };

  const originalLayouts = JSON.parse(
    JSON.stringify(loadFromLocalStorage("cardsOrderPerformance") || {})
  );
  const [layouts, setLayouts] = useState(originalLayouts);
  const [widgets, setWidgets] = useState(null);

  useEffect(() => {
    globalServices
      .getActiveWidgetsPerf()
      .then((res) => {
        setWidgets(res.data.data);
      })
      .catch((err) => console.log(err.response));
  }, [updatePerformances]);

  return (
    <>
      <ResponsiveGridLayout
        className="layout"
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        rowHeight={150}
        layouts={layouts}
        width={1200}
        isDraggable={true}
        isResizable={false}
        onLayoutChange={(layout, layouts) => onLayoutChange(layout, layouts)}
      >
        {widgets &&
          widgets.map((widget) => {
            return (
              <Card
                key={`${widget.cardKey}`}
                data-grid={JSON.parse(widget.dataGrid)}
                className={`${widget.className}`}
              >
                <Card.Header>{translator(widget.name)}</Card.Header>
                <Card.Body>{ReactHtmlParser(widget.value)}</Card.Body>
              </Card>
            );
          })}
      </ResponsiveGridLayout>
    </>
  );
};

export default DashboardLayoutPerformance;
